import PoiSubSledge from "@/components/PoiSubSledge/PoiSubSledge.vue";
export default {
  extends: PoiSubSledge
};
